import { useState, useEffect } from 'react';
import { ServiceFormPlanoService } from './Service';
import moment from 'moment';
import { usePlanoForm } from './Context';
import { Settings } from 'lucide-react';

const serviceFormPlanoService = new ServiceFormPlanoService();
type Props = {
    serviceId: string;
    recurrence: number;
};

type Agendamento = {
    diaSemana: number;
    horario: string;
};

type FormState = {
    personalizar: boolean;
    config: Agendamento;
    configs: Agendamento[];
};

const diasSemana = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
];

export function PlanoCard({
                              serviceId, recurrence,
                          }: Props) {
    const { startAt } = usePlanoForm();
    const [loading, setLoading] = useState(false);
    const [horarios, setHorarios] = useState<moment.Moment[]>([]);
    const [formState, setFormState] = useState<FormState>({
        personalizar: recurrence > 4,
        config: { diaSemana: 0, horario: '' },
        configs: Array.from({ length: recurrence }, () => ({ diaSemana: 0, horario: '' })),
    });

    const updateField = (
        index: number | 'default',
        field: keyof Agendamento,
        value: string,
    ) => {
        setFormState(prev => {
            if (index === 'default') {
                return {
                    ...prev,
                    defaultConfig: {
                        ...prev.config,
                        [field]: field === 'diaSemana' ? Number(value) : value,
                    },
                };
            }

            const newList = [...prev.configs];
            newList[index] = {
                ...newList[index],
                [field]: field === 'diaSemana' ? Number(value) : value,
            };
            return { ...prev, agendamentos: newList };
        });
    };

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);

                const doc: any = { startAt, recurrence };

                if (formState.personalizar) {
                    doc.configs = formState.configs;
                } else {
                    doc.config = formState.config;
                }

                const { data } = await serviceFormPlanoService.getHorarios(doc);

                setHorarios(data.map((e: string) => moment(e)));
            } catch (e) {

            } finally {
                setLoading(false);
            }
        })();

    }, [formState]);

    return (
        <div className={`p-4 bg-base-100 rounded-lg shadow ${loading && 'opacity-45'}`}>
            {recurrence > 1 && recurrence <= 4 && (
                <label className="flex items-center gap-2 cursor-pointer">
                    <Settings aria-hidden="true" />
                    <span>Personalizar dias e horários</span>
                    <input
                        type="checkbox"
                        checked={formState.personalizar}
                        onChange={() =>
                            setFormState(prev => ({
                                ...prev,
                                personalizar: !prev.personalizar,
                            }))
                        }
                        className="toggle toggle-primary"
                    />
                </label>
            )}

            {formState.personalizar ? (
                formState.configs.map((ag, idx) => (
                    <div key={idx} className="mt-4">
                        <label className="block mb-1 text-sm font-medium">
                            Agendamento {idx + 1}
                        </label>
                        <div className="flex gap-2">
                            <select
                                className="select select-sm select-bordered"
                                value={ag.diaSemana}
                                onChange={e => updateField(idx, 'diaSemana', e.target.value)}
                            >
                                {diasSemana.map((d, i) => (
                                    <option key={i} value={i}>
                                        {d}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="time"
                                className="input input-sm input-bordered"
                                value={ag.horario}
                                onChange={e => updateField(idx, 'horario', e.target.value)}
                            />
                        </div>
                    </div>
                ))
            ) : (
                <div className="mt-4">
                    <label className="block mb-1 text-sm font-medium">
                        Agendamentos Gerais
                    </label>
                    <div className="flex gap-2">
                        <select
                            className="select select-sm select-bordered"
                            value={formState.config.diaSemana}
                            onChange={e => updateField('default', 'diaSemana', e.target.value)}
                        >
                            {diasSemana.map((d, i) => (
                                <option key={i} value={i}>
                                    {d}
                                </option>
                            ))}
                        </select>
                        <input
                            type="time"
                            className="input input-sm input-bordered"
                            value={formState.config.horario}
                            onChange={e => updateField('default', 'horario', e.target.value)}
                        />
                    </div>
                </div>
            )}

            {horarios?.length && <div className="divider" />}

            <div className="space-y-2">
                {
                    horarios.map(e => (
                        <div className="text-xs sm:text-md">
                            {moment(e).format('DD/MM/YYYY')} - {moment(e).format('dddd')} - {moment(e).format('HH:mm')}
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
